import { Box, Stack, Typography } from '@mui/material'
import { paths } from 'app/routes'
import logoSrc from 'assets/images/logo.svg'
import projectNameSrc from 'assets/images/project-name.svg'
import { Link } from 'elements/navigation/link'
import { useTranslation } from 'react-i18next'
import { useMatch } from 'react-router-dom'

import { BackgroundDecoration } from './background-decoration'

type UnauthLayoutProps = {
  children: React.ReactNode
}

export const UnauthLayout = ({ children }: UnauthLayoutProps) => {
  const { t } = useTranslation()

  const isRegistrationPage = Boolean(useMatch(paths.signUp))

  const isLoginPage = Boolean(useMatch(paths.signIn))

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        pt: 7.5,
        minHeight: '100vh',
      }}
    >
      <BackgroundDecoration
        tripleBottomDecoration={!isRegistrationPage}
        withTopDecoration
      />

      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'center',
          alignItems: { xs: 'center', md: 'start' },
          mb: 6,
          px: 2,
        }}
      >
        {(isRegistrationPage || isLoginPage) && (
          <Box mr={4} maxWidth={282} mb={{ xs: 4, lg: 0 }}>
            <Link to={paths.signIn}>
              <Box
                component="img"
                src={logoSrc}
                alt="Libraria"
                width={74}
                height={80}
                mb={2.5}
                ml={4}
              />
              <Box
                component="img"
                src={projectNameSrc}
                alt="Libraria"
                display="block"
                mb={2.25}
              />
            </Link>

            <Typography variant="body2">
              {t('common.manage_your_translations')}
            </Typography>
          </Box>
        )}

        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          width="100%"
          maxWidth={486}
        >
          {children}
        </Box>
      </Box>

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={4}
        mt="auto"
        mb={4}
        px={4}
        zIndex={10}
      >
        <Typography variant="caption2" color="text.secondary">
          {t('common.all_rights_reserved')}
        </Typography>
        <Link to="">{t('common.privacy_policy')}</Link>
        <Link to="">{t('common.terms_of_service')}</Link>
        <Link to="">{t('common.cookie_settings')}</Link>
      </Stack>
    </Box>
  )
}
